module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('privat-otp-auth-blank-form', {
    attrs: {
      "submit-label": "Отправить",
      "user": _vm.user,
      "errors": _vm.errors
    },
    on: {
      "submit": _vm.processOtpAuthForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c31aa66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/privat_otp_auth/PrivatOtpAuthForm.vue
// module id = 690
// module chunks = 0